module.exports = __webpack_public_path__ + "img/ImageIcon.27cd6a02.svg";